define([
    './directives/StickyHeaderDirective',
    './directives/StickyFooterDirective',
    './directives/PageDrawerSlideoutDirective'
], (StickyHeader, StickyFooter, PageDrawerSlideoutDirective)=> {
    return angular.module('edge.platform.widgets.pagestructure', [])
        .constant('phoneMediaBreakpoint', 639)// in px
        .directive('gwPlStickyHeader', StickyHeader)
        .directive('gwPlStickyFooterWrapper', StickyFooter)
        .directive('gwPlPageDrawerSlideout', PageDrawerSlideoutDirective);
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/pagestructure/module.js
 **/